import React, {Component} from 'react'
import Reader from '../../controller/Reader'
import Creater from '../../controller/Creater'
import Updater from '../../controller/Updater'
import Deleter from '../../controller/Deleter'
import Alert from '../etc/Alert'

export default class DocsEdit extends Component {

	state = { 
        idName : '',
        title : '',
        description : '',
        isAlert : false,
        alertTxt : ''
    }

    componentDidMount() {

        if(this.props.catg !== '') {

            this.getFx()
        
        } 

    }


    getFx = () => {
    
        const condition = {
    
            url : '/api/docs/detail/' + this.props.catg
        }
        
        Reader(condition, res => {

            if(res.data !== null) {

                this.setState({
                    idName : res.data._id,
                    title : res.data.title,
                    description : res.data.description
                })
            }
        })
    }


    cancelFx = () => {

        this.setState({
            idName : '',
            title : '',
            description : '',
        })

        this.props.cancelMe()
    }

    changeFx = (e) => {

        if(e.target.id === 'title') {

            this.setState({
                title : e.target.value
            })

        } else {
            
            this.setState({
                description : e.target.value
            })
        }
    }


    deleteFx = () => {

        if(this.props.catg === '') {
        
            this.setState({
                title : '',
                description : ''
            })
        
        } else {

            let condition = {
                url : '/api/docs/delete/' + this.state.idName
            }
    
            Deleter(condition, res => {

                if(res.message === 'blocked' || res.message === 'ERROR') {
        
                    this.setState({ 
                        alertTxt : 'Access Denied!',
                        isAlert : true
                    })
                    
                    return

                } else {

                    this.setState({
                        alertTxt : 'Deleted!',
                        isAlert : true
                    })

                }
            })
        }
    }


    saveFx = () => {

        if(this.state.title.length <= 0 || this.state.description.length <= 0) {
            this.setState({
                alertTxt : 'Please fill in title, or description!',
                isAlert : true
            })

            return
        }


        if(this.props.catg === '') {

            let condition = {
                url : '/api/docs/add',
                data : {
                    title : this.state.title,
                    description : this.state.description
                }
            }
    
            Creater(condition, res => {
    
                if(res.message === 'blocked' || res.message === 'ERROR') {
        
                    this.setState({ 
                        alertTxt : 'Access Denied!',
                        isAlert : true
                    })

                    return
    
                } else{

                    this.setState({
                        alertTxt : 'Success!',
                        isAlert : true
                    })

                    return
                }
    
            })    

        } else {
        
            let condition = {
                url : '/api/docs/update/' + this.props.catg,
                data : {
                    _id: this.state.idName,
                    title: this.state.title,
                    description: this.state.description
                }
            }
    
            Updater(condition, res => {
                
                if(res.message === 'blocked' || res.message === 'ERROR') {

                    this.setState({ 
                        alertTxt : 'Access Denied!',
                        isAlert : true
                    })

                    return
    
                } else {

                    this.setState({
                        alertTxt : 'Update Success!',
                        isAlert : true
                    })
                    
                    return
                }

            })
        }

    }


    closeFx = () => {
        this.setState(
            { isAlert : false }
        )
    }


    render() {

        return (

            <React.Fragment>

                { this.state.isAlert ? <Alert alert = { this.state.alertTxt } closeMe = { this.closeFx } /> : null }
               
                <div className = 'DocsPostBox'>

                    <span id = 'DocsEditTitle'>

                    { this.props.catg === '' ? 'Write a new post' : 'Edit an existing post'}    
                                                
                    </span>

                    <input id='title' type='text' value={this.state.title} onChange={this.changeFx} />

                    <textarea id='desc' value={this.state.description} onChange={this.changeFx} />

                </div>

                <div style={{textAlign : 'center'}}>
                    <span className='RegBtn' onClick = {this.cancelFx}>CANCLE</span>
                    <span className='RegBtn' onClick = {this.deleteFx}>DELETE</span>
                    <span className='RegBtn' onClick = {this.saveFx}>SAVE</span>

                </div>
                
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/docs/DocsEdit.js